import { gql } from "@apollo/client";

export const CREATE_VEHICLES_TRANSER = gql`
  mutation transferVehicles($vehicleIds: [ID!], $destinationBranchId: ID!) {
    transferVehicles(vehicleIds: $vehicleIds, destinationBranchId: $destinationBranchId) {
      success
    }
  }
`;